import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["faction"],
  _excluded2 = ["sections", "radius"];
import { jsx, Fragment } from 'react/jsx-runtime';
import { createStyles, Progress } from '@mantine/core';
import { forwardRef } from 'react';
import { FindFactionColor } from '../FactionColors.js';
var sectionConvert = function sectionConvert(_ref) {
  var faction = _ref.faction,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread({
    color: FindFactionColor(faction != null ? faction : "neutral", {
      neutral: "dimmed"
    })
  }, rest);
};
var useStyles = createStyles(function () {
  return {
    root: {
      div: {
        transition: "width 300ms, background-color 300ms ease-in-out"
      }
    }
  };
});
var WarzoneProgress = forwardRef(function (_ref2, ref) {
  var _ref2$sections = _ref2.sections,
    sections = _ref2$sections === void 0 ? [] : _ref2$sections,
    _ref2$radius = _ref2.radius,
    radius = _ref2$radius === void 0 ? 0 : _ref2$radius,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var renderSections = sections && Array.isArray(sections) ? sections.map(sectionConvert) : [];
  return /* @__PURE__ */jsx(Fragment, {
    children: /* @__PURE__ */jsx(Progress, _objectSpread({
      classNames: classes,
      ref: ref,
      size: "lg",
      sections: renderSections,
      radius: radius
    }, rest))
  });
});
WarzoneProgress.displayName = "WarzoneProgress";
export { WarzoneProgress };